import { FormEvent, useState } from 'react';
import { login } from '../lib/api';

interface Props { onAuthenticated: (role: 'student' | 'teacher' | 'admin') => void; }

export default function LoginScreen({ onAuthenticated }: Props) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const actor = await login(email, password);
      onAuthenticated(actor.role);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed.');
    } finally {
      setBusy(false);
    }
  }

  return <main className="auth-shell">
    <section className="auth-card">
      <p className="eyebrow">TALKUP · SECURE ACCESS</p>
      <h1>Learn together.</h1>
      <p>Sign in to continue to your teacher-led language workspace.</p>
      <form onSubmit={submit}>
        <label>Email<input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        <label>Password<input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
        {error && <p className="form-error" role="alert">{error}</p>}
        <button disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <p><a href="/?setup=1">First-time school setup</a></p>
      </form>
    </section>
  </main>;
}
